module.exports = __webpack_public_path__ + "static/img/news78.cdcd437.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/newscenter/news78.webp
// module id = c2R4
// module chunks = 0